import { TimePickerChip } from "../../../../components/buttons/IconButtons";
import ReadIndicator from "./ReadIndicator";

/**
 *
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 * NotificationDetail Component
 *
 * Renders a detailed notification card with icon, title, description,
 * elapsed time, and an optional action button (download or review).
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {string} props.title - Notification title.
 * @param {string} props.description - Notification description text.
 * @param {string} props.elapsedTime - Human-readable elapsed time (e.g., "2 hours ago").
 * @param {string|number} props.idSelected - ID used to match against notification items for icon/color.
 * @param {boolean} [props.isReport=false] - Whether this notification corresponds to a downloadable report.
 * @param {Function} [props.onMarkAsRead] - Callback fired when marking the notification as read.
 * @param {Function} [props.onDownload] - Callback fired when downloading the report.
 * @param {Function} [props.onAction] - Callback fired for a non-report action (e.g., review).
 *
 * @returns {JSX.Element} The rendered notification detail card.
 */
const NotificationDetail = (props) => {
    const {
        id,
        icon,
        title = "",
        description = "",
        elapsedTime = "",
        read = false,
        readIndicatorClass,
        unreadIndicatorClass,
        iconClass,
        onMarkAsRead = () => { },
        getButton = null
    } = props;

    const finalIconClass = read ? readIndicatorClass : unreadIndicatorClass;

    return (
        <div id={id} className={`notification-container p-2 d-flex flex-row gap-2 w-100 align-items-start ${read ? "read-hover" : ""}`} onClick={!read ? onMarkAsRead : undefined}>
            {/* Read indicator */}
            <ReadIndicator read={read} readIndicatorClass={finalIconClass}/>

            <div className={`rounded-3 p-3 flex-grow-1 d-flex flex-column justify-content-between
                ${read ? "background-shades-50 " : "background-hover-shades-200 background-shades-100 border-full-shades-100 cursor-pointer"}`}
            >
                <div className="d-flex gap-2">
                    {/* Dynamic icon */}
                    <div className={`${iconClass} h-52px w-52px d-flex align-items-center justify-content-center`}>
                        {icon}
                    </div>

                    {/* Notification content */}
                    <div className="text-break">
                        <p className="fs-14px ibl-font-w-600 mb-1">{title}</p>
                        <p className="fs-12px font-color-shades-500">{description}</p>

                        <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                            <TimePickerChip />
                            <p className="fs-10px mb-0">{elapsedTime}</p>
                        </div>
                    </div>
                </div>

                {/* Action button */}
                <div className="d-flex justify-content-center align-items-center gap-2 pt-2 mt-2  mt-md-0">
                    {getButton && getButton(props)}
                </div>
            </div>
        </div>
    );
};

export default NotificationDetail;
